import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { environment} from '../environments/environment';
import { LoopBackConfig } from './shared/sdk';

import { Subscription } from 'rxjs';
import { IMqttMessage, IMqttServiceOptions, MqttService } from 'ngx-mqtt';
import { NgEventBus } from 'ng-event-bus';
import { MosquittoConfig } from './shared/mosquitto';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private subscriptionLife: Subscription;
  public message: string;
  
  constructor(
    private router: Router,
    private mqttService: MqttService,
    private eventBus: NgEventBus,
  ) {
    console.log('AppComponent constructor');
    const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
      connectOnCreate: MosquittoConfig.isConnectOnCreate(),
      hostname: MosquittoConfig.getHostname(),
      port: MosquittoConfig.getPort(),
      path: MosquittoConfig.getPath(),
      protocol: MosquittoConfig.getProtocol(),
      url: 'https://predikt-ai.thingtrack.com/mqtt' // Puedes usar esta URL si prefieres
    };
    console.log(MQTT_SERVICE_OPTIONS)
    // configure Loopback URL service
    LoopBackConfig.setBaseURL(environment.BASEURL);
    LoopBackConfig.setAuthPrefix('Bearer ');
    LoopBackConfig.filterOnUrl();
    this.mqttService.connect({
      url: 'wss://predikt-ai.thingtrack.com/mqtt', // Puedes usar esta URL si prefieres
    });
    // mqtt subscription
    this.subscription = this.mqttService.observe('/mqtt/events').subscribe((message: IMqttMessage) => {
        this.message = message.payload.toString();
        // emit event set active event
        console.log('Received MQTT message:', this.message);
        this.eventBus.cast('event:register', JSON.parse(this.message));
    });
    this.subscription = this.mqttService.observe('/mqtt/sessions/#').subscribe((message: IMqttMessage) => {
      this.message = message.payload.toString();
      let session = JSON.parse(this.message);
      switch (message.topic) {
        case '/mqtt/sessions/openned':
          session.statusSession = 'OPENNED';
          break;
        case '/mqtt/sessions/closed':
          session.statusSession = 'CLOSED';
          break
      }
      // emit event set active event
      this.eventBus.cast('event:sessions', session);
  });
    // this.subscriptionLife = this.mqttService.observe('/mqtt/lifes').subscribe((message: IMqttMessage) => {
    //   this.message = message.payload.toString();
      
    //   // emit event set active event
    //   this.eventBus.cast('event:life', JSON.parse(this.message));
    // });

    // publish a message
    //this.mqttService.unsafePublish("/mqtt/events", "hello from UI!");
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
